export default __webpack_public_path__ + "e172b1d2b0e539420c47874938f79d1c.svg";